/* eslint-disable */
import * as Types from '../../../../../models/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetFoodListVariablesDTO = Types.Exact<{
  search?: Types.Maybe<Types.Scalars['String']>;
  paging?: Types.Maybe<Types.PagingDTO>;
  sort?: Types.Maybe<Array<Types.Maybe<Types.SortDTO>> | Types.Maybe<Types.SortDTO>>;
}>;


export type GetFoodListDTO = (
  { __typename?: 'Query' }
  & { foods: Array<(
    { __typename?: 'Food' }
    & Pick<Types.FoodDTO, 'id'>
    & { name: Types.FoodDTO['titleInLanguage'] }
  )> }
);


export const GetFoodListDocumentDTO = gql`
    query getFoodList($search: String, $paging: Paging, $sort: [Sort]) {
  foods(
    filter: {titleInLanguage: {language: en, text: {contains: $search}}}
    paging: $paging
    sort: $sort
  ) {
    id
    name: titleInLanguage(language: en)
  }
}
    `;

/**
 * __useGetFoodList__
 *
 * To run a query within a React component, call `useGetFoodList` and pass it any options that fit your needs.
 * When your component renders, `useGetFoodList` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFoodList({
 *   variables: {
 *      search: // value for 'search'
 *      paging: // value for 'paging'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetFoodList(baseOptions?: Apollo.QueryHookOptions<GetFoodListDTO, GetFoodListVariablesDTO>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFoodListDTO, GetFoodListVariablesDTO>(GetFoodListDocumentDTO, options);
      }
export function useGetFoodListLazyQueryDTO(baseOptions?: Apollo.LazyQueryHookOptions<GetFoodListDTO, GetFoodListVariablesDTO>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFoodListDTO, GetFoodListVariablesDTO>(GetFoodListDocumentDTO, options);
        }
export type GetFoodListHookResult = ReturnType<typeof useGetFoodList>;
export type GetFoodListLazyQueryDTOHookResult = ReturnType<typeof useGetFoodListLazyQueryDTO>;
export type GetFoodListQueryResultDTO = Apollo.QueryResult<GetFoodListDTO, GetFoodListVariablesDTO>;